import React from "react";
import { IconProps } from "./IconProps";

const ChevronArrowRight: React.FC<IconProps> = ({
    size = 22,
    color = "#F7F9F9",
    ...props
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 22 22"
            fill="none"
            {...props}
        >
            <path
                d="M8.50948 16.0049L13.4999 10.9952L8.49023 6.00488"
                stroke={color}
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default ChevronArrowRight;
